import styled from "styled-components";

export const PageContainer = styled.div`
  margin-top: 24px;
  max-width: 1520px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 100px;
`;
